import {requestMs} from "@helpers/api";

export const media = {
  getFullImage: params => requestMs.post('/api3/image', params),
  getContractPdf: (params) => requestMs.post('/api3/image', params)
};
